import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=5313b079&scoped=true&"
import script from "./CourseCard.vue?vue&type=script&lang=js&"
export * from "./CourseCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=5313b079&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313b079",
  null
  
)

export default component.exports